import React, { useState, useEffect } from "react";
import { Form, Button, Modal, InputGroup } from "react-bootstrap";
import dayjs from "dayjs";
import { Icon } from "@iconify/react";
import { API_BASE_URL } from "./../config";
import axios from "axios"; // Certifique-se de que o axios está configurado.

const Turmas = ({ turmas, onSelectTurma }) => {
  const [selectedTurma, setSelectedTurma] = useState(null);
  const [cursoNome, setCursoNome] = useState("");
  const [showInfoModal, setShowInfoModal] = useState(false);

  // Buscar o nome do curso pelo ID do curso
  const fetchCursoNome = async (cursoId) => {
      try {
        const response = await axios.get(`${API_BASE_URL}/cursos/${cursoId}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        setCursoNome(response.data.cp_nome_curso || "Não disponível");
      } catch (error) {
      console.error("Erro ao buscar o nome do curso:", error);
      setCursoNome("Não disponível");
    }
  };

  const handleSelectChange = async (turmaId) => {
    const turma = turmas.find((t) => t.cp_tr_id === parseInt(turmaId));
    setSelectedTurma(turma || null);
    onSelectTurma(turmaId);

    if (turma && turma.cp_tr_curso_id) {
      await fetchCursoNome(turma.cp_tr_curso_id); // Buscar o nome do curso
    }
  };

  const handleShowInfo = () => {
    if (selectedTurma) {
      setShowInfoModal(true);
    }
  };

  const handleCloseInfo = () => {
    setShowInfoModal(false);
  };

  return (
    <>
      <div className="turmas-panel">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-2">
            <div className="flex-grow-1">
                <label className="form-label text-label fw-bold small text-uppercase mb-2 d-flex align-items-center gap-2" style={{letterSpacing: '0.5px'}}>
                    <Icon icon="mdi:cursor-default-click-outline" className="text-primary" width="16" />
                    Selecione a Turma
                </label>
                <InputGroup className="turmas-panel__select shadow-sm">
                    <InputGroup.Text className="border-end-0 bg-theme-surface text-primary">
                        <Icon icon="mdi:google-classroom" width="22" />
                    </InputGroup.Text>
                    <Form.Select
                        value={selectedTurma ? selectedTurma.cp_tr_id : ""}
                        onChange={(e) => handleSelectChange(e.target.value)}
                        className="form-select-lg border-start-0 shadow-none fw-semibold py-3"
                        style={{ fontSize: '1rem', cursor: 'pointer' }}
                    >
                        <option value="" disabled>
                            {turmas.length > 0 ? "Clique aqui para selecionar uma turma..." : "Nenhuma turma disponível"}
                        </option>
                        {turmas.map((turma) => (
                            <option key={turma.cp_tr_id} value={turma.cp_tr_id}>
                                {turma.cp_tr_nome}
                            </option>
                        ))}
                    </Form.Select>
                </InputGroup>
            </div>

            {selectedTurma && (
                <div className="d-flex align-items-center gap-2 pt-2 pt-md-0 flex-wrap">
                    <div className="d-none d-md-block border-start mx-3" style={{ height: "40px" }}></div>
                    <div className="pe-2">
                        <small className="text-label d-block text-uppercase fw-bold" style={{ fontSize: "0.7rem" }}>Curso</small>
                        <span className="fw-semibold text-value">{cursoNome}</span>
                    </div>
                    <div className="border-start mx-2" style={{ height: "20px" }}></div>
                    <div className="pe-2">
                         <small className="text-label d-block text-uppercase fw-bold" style={{ fontSize: "0.7rem" }}>Professor</small>
                         <span className="fw-semibold text-value">{selectedTurma.nomeDoProfessor}</span>
                    </div>
                    <Button
                        variant="light"
                        className="turmas-panel__info-btn rounded-circle p-2 ms-md-2 text-primary bg-primary-subtle border-0 shadow-sm"
                        onClick={handleShowInfo}
                        title="Mais detalhes"
                    >
                        <Icon icon="mdi:information-variant" width="20" />
                    </Button>
                </div>
            )}
        </div>
      </div>

      {/* Modal para mostrar informações da turma */}
      {selectedTurma && (
        <Modal show={showInfoModal} onHide={handleCloseInfo} centered contentClassName="border-0 shadow-lg" style={{ borderRadius: "16px" }}>
          <Modal.Header closeButton className="border-0 pb-0">
            <Modal.Title className="fw-bold">Detalhes da Turma</Modal.Title>
          </Modal.Header>
          <Modal.Body className="pt-2">
            <div className="p-3 turma-info-box rounded-3 mb-3">
                <h5 className="text-primary fw-bold mb-0">{selectedTurma.cp_tr_nome}</h5>
                <small className="text-muted">{cursoNome}</small>
            </div>
            <div className="d-flex flex-column gap-2">
                <div className="d-flex justify-content-between border-bottom pb-2">
                    <span className="text-muted">Data de Início</span>
                    <span className="fw-semibold">{dayjs(selectedTurma.cp_tr_data).format("DD/MM/YYYY")}</span>
                </div>
                <div className="d-flex justify-content-between border-bottom pb-2">
                    <span className="text-muted">Professor Responsável</span>
                    <span className="fw-semibold">{selectedTurma.nomeDoProfessor}</span>
                </div>
                <div className="d-flex justify-content-between border-bottom pb-2">
                    <span className="text-muted">Escola/Unidade</span>
                    <span className="fw-semibold">{selectedTurma.nomeDaEscola}</span>
                </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="border-0">
            <Button variant="secondary" onClick={handleCloseInfo} className="px-4 rounded-pill">
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default Turmas;
